import RouterBasic from '../module/basic/js/RouterBasic';
import RouterSystem from '../module/system/js/RouterSystem';
import RouterRoles from '../module/role/js/RouterRole';
import RouterDevice from '../module/device/js/RouterDevice';
import RoyterDispatch from '../module/dispatch/js/RouterDispatch';
import RouterMonitor from "../module/monitor/js/RouterMonitor";
import RouterQuery from "../module/query/js/RouterQuery";
import RouterMedicalDisposal from '../module/medicalDisposal/js/RouterQuery'
//获取路由
export function getRouter() {
    let childrenRouter = RouterBasic;
    childrenRouter = childrenRouter.concat(RouterSystem);
    childrenRouter = childrenRouter.concat(RouterRoles);
    childrenRouter = childrenRouter.concat(RouterDevice);
    childrenRouter = childrenRouter.concat(RoyterDispatch);
    childrenRouter = childrenRouter.concat(RouterMonitor);
    childrenRouter = childrenRouter.concat(RouterQuery);
    childrenRouter = childrenRouter.concat(RouterMedicalDisposal);
    return childrenRouter
}
